// Generated by purs version 0.11.7
"use strict";
var $foreign = require("./foreign");
var FRP_Event = require("../FRP.Event");
module.exports = {
    down: $foreign.down,
    up: $foreign.up,
    withKeys: $foreign.withKeys
};



//////////////////
// WEBPACK FOOTER
// ./output/FRP.Event.Keyboard/index.js
// module id = 327
// module chunks = 0